import React from 'react'
import './participationSteps.scss'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby'
import useGetInscription from '../../../utils/hooks/useGetInscription'
import {
  numberOfSelected,
  winnersOfChanllenge,
} from '../../../constants/activity-constants'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ParticipationSteps = ({ section = '' }) => {
  const [isAmbassador, isLoading] = useGetInscription()

  const infoCards = [
    {
      title: 'Mantén tu perfil público',
      description: (
        <p>
          Es muy importante que <b>tu perfil sea público</b> para que podamos
          verlo todo
        </p>
      ),
    },
    {
      title: `Usa el hashtag oficial`,
      description: (
        <p>
          No olvides usar el hashtag <b>#EmbajadorasNosotras2022</b> en todas
          tus publicaciones
        </p>
      ),
    },
    {
      title: 'No pares de crear',
      description: (
        <p>
          Crea contenido auténtico y mantente <b>súper activa en tus redes.</b>
        </p>
      ),
    },
    {
      title: 'Corre la voz',
      description: (
        <p>
          Comparte los <b>beneficios de la Tecnología Cur-V</b> con todas tus
          conocidas y publica fotos, videos, etc.
        </p>
      ),
    },
  ]

  return (
    <section className="f-participation-steps">
      <div className="f-participation-steps__wrapper">
        <h2 className="f-participation-steps__title">
          ¡Cumplir con tu labor como Embajadora es muy fácil!
        </h2>

        <div className="f-participation-steps__cards">
          {infoCards.map((card, i) => {
            return (
              <div
                key={`card=${i + 1}`}
                className="f-participation-steps__card"
              >
                <span className="f-participation-steps__card__number">
                  {i + 1}
                </span>
                <h3 className="f-participation-steps__card__title">
                  {card.title}
                </h3>
                {card.description}
              </div>
            )
          })}
        </div>
        <div className="f-participation-steps__button">
          {/* {section === 'home' && ( */}
            <Button
              title={'CONOCE MÁS'}
              onClick={() => {
                pushEventDataLayer({
                  event: 'Interacciones - Conoce más',
                  category: 'embajadoras-curv',
                  action: 'click',
                  label: 'CONOCE MÁS',
                  location: 'nosotras.com/embajadoras',
                })
                navigate('/ser-embajadora')
              }}
              color="blue"
            />
          {/* )} */}
          {/* {section !== 'home' && !isAmbassador && (
            <Button
              title={'INSCRÍBETE AQUÍ'}
              onClick={() => {
                pushEventDataLayer({
                  event: 'Interacciones - Inscripción',
                  category: 'embajadoras-curv',
                  action: 'click',
                  label: 'INSCRÍBETE AQUÍ',
                  location: 'nosotras.com/embajadoras',
                })
                navigate('/inscripcion')
              }}
              color="blue"
            />
          )} */}
        </div>
      </div>
    </section>
  )
}

export default ParticipationSteps
